module.exports = __webpack_public_path__ + "images/stickers/pete-sketch@2x.3808b148cca5b1ed3da0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-sketch@2x.png
// module id = N7Me
// module chunks = 1